import { createRequiredContext } from '../createRequiredContext';
const { useContext, Provider, Context, Consumer } = createRequiredContext('FedopsProvider');
export const FedopsProvider = Provider;
export const FedopsConsumer = Consumer;
export const FedopsContext = Context;
export const useFedops = useContext;
//# sourceMappingURL=FedopsProvider.js.map